import { axios } from '@/utils/request'

export function getCompanyHistory () {
    return axios({
        url: '/company-history/',
        method: 'get'
    })
}
